import { ApppointmentTabTypesEnum, Auth, FindDashboardSummary } from '@/@types';

import { Variants, motion } from 'framer-motion';
import { useMemo } from 'react';
import { NeedAnythingCard, withPermission } from '../..';
import { AppointmentCard } from './appointmentCard';
import { ResultCard } from './resultCard';
import { MedicationCard } from './medicationCard';
import { DocumentCard } from './documentCard';

const container: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      stiffness: 50,
      staggerChildren: 0.1,
    },
  },
};

const itemVariant: Variants = {
  show: { opacity: 1 },
  hidden: { opacity: 0 },
};

type Props = {
  summary?: FindDashboardSummary;
};

export function HomeCards({ summary }: Props) {
  const hasGap = useMemo(() => {
    return (
      !summary?.appointments?.future &&
      !summary?.appointments.previous &&
      !summary?.imagingResults &&
      !summary?.labResults &&
      !summary?.medicationsList?.length &&
      !summary?.favoriteDocument
    );
  }, [summary]);

  const NeedAnyCard = withPermission(
    NeedAnythingCard,
    Auth.Permissions.UserPermissions.CONTACT_CARE_TEAM
  );

  return (
    <motion.div
      initial='hidden'
      animate='show'
      variants={container}
      className='grid grid-cols-1 lg:grid-cols-2 justify-start gap-6'
    >
      {summary?.appointments?.future && (
        <motion.div variants={itemVariant}>
          <AppointmentCard
            type={ApppointmentTabTypesEnum.UPCOMING}
            appointment={summary?.appointments?.future}
          />
        </motion.div>
      )}
      {summary?.appointments.previous && (
        <motion.div variants={itemVariant}>
          <AppointmentCard
            type={ApppointmentTabTypesEnum.PAST}
            appointment={summary?.appointments?.previous}
          />
        </motion.div>
      )}
      {summary?.imagingResults && (
        <motion.div variants={itemVariant}>
          <ResultCard type='imaging' result={summary.imagingResults} />
        </motion.div>
      )}
      {summary?.labResults && (
        <motion.div variants={itemVariant}>
          <ResultCard type='lab' result={summary.labResults} />
        </motion.div>
      )}
      {!!summary?.medicationsList?.length && (
        <motion.div variants={itemVariant}>
          <MedicationCard medications={summary?.medicationsList} />
        </motion.div>
      )}
      {summary?.favoriteDocument && (
        <motion.div variants={itemVariant}>
          <DocumentCard document={summary?.favoriteDocument} />
        </motion.div>
      )}
      <NeedAnyCard widthFull={hasGap} />
    </motion.div>
  );
}
